"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
require("magnific-popup");
var TermsModal = /** @class */ (function () {
    function TermsModal() {
        if (document.querySelector('.js-terms')) {
            this.init();
        }
    }
    TermsModal.getInstance = function () {
        return new TermsModal();
    };
    TermsModal.prototype.init = function () {
        var $termsBtn = $('.js-terms'), $closeBtn = $('.js-close-modal'), $body = $('html');
        $closeBtn.on('click', function (e) {
            e.preventDefault();
            $('.mfp-close').trigger('click');
        });
        $termsBtn.magnificPopup({
            type: 'inline',
            midClick: true,
            callbacks: {
                open: function () {
                    $body.addClass('no-scroll');
                },
                close: function () {
                    $body.removeClass('no-scroll');
                }
            }
        });
    };
    return TermsModal;
}());
exports.default = TermsModal;
